import { render, staticRenderFns } from "./cuotas.vue?vue&type=template&id=2d453805&scoped=true&"
import script from "./cuotas.vue?vue&type=script&lang=js&"
export * from "./cuotas.vue?vue&type=script&lang=js&"
import style0 from "./cuotas.vue?vue&type=style&index=0&id=2d453805&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d453805",
  null
  
)

export default component.exports